import React, { useContext, useEffect, useState } from "react";

import { GetUnityDataById } from "../../services/Api/unity";

import { ScrollView, StyleSheet, Text, View } from "react-native";
import PageTitle from "../../components/PageTitle";
import UnityModalPopUp from "../../components/UnityModalPopUp";
import { GlobalContext } from "../../contexts/global";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import Info from "./components/Info";
import OpeningHours from "./components/OpeningHours";
import PaymentMethods from "./components/PaymentMethods";
import Services from "./components/Services";
import UnityMap from "./components/UnityMap";

export default function UnityDetails({ navigation, route }) {
  const [unityData, setUnityData] = useState(null);
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
  useEffect(()=> setLoading({
    show: true,
    message: "Carregando dados da unidade",
  }),[])
  
  const [isPopUpVisible, setStatePopUp] = useState(false);
  const unityId = route.params;

  useEffect(() => {
    (async () => {
      GetUnityDataById(unityId)
        .then((value) => {
          setUnityData(value);
          setLoading({ show: false, message: "" });
        })
        .catch((error) => {
          setShowAlert({
            type: "alert",
            title: "Atenção",
            message: "Ocorreu um erro ao tentar consultar os dados da unidade",
            show: true,
            confirmText: "Tentar Novamente",
            pressConfirm: () => {
              setShowAlert({ ...showAlert, show: false });
              navigation.goBack();
            },
          });
        })
        .finally(() => setLoading({ show: false, message: "" }));
    })();
  }, []);

  return (
    <PageTitle title={"ESTACIONAMENTO"} navigation={navigation}>
      <ScrollView
        contentContainerStyle={{ flexGrow: 1 }}
        showsVerticalScrollIndicator={false}
        showsHorizontalScrollIndicator={false}
      >
        {unityData ? (
          <>
            <UnityMap unityData={unityData} setStatePopUp={setStatePopUp} />
            {/* <View style={styles.viewData}> */}
            <Text style={styles.unityName}>{unityData.name.toUpperCase()}</Text>
            <View style={styles.viewSubdata}>
              <OpeningHours
                unityData={unityData}
                setStatePopUp={setStatePopUp}
              />
            </View>
            <Text style={styles.unityName}>{"TABELA DE PREÇO"}</Text>
            <View style={styles.viewSubdata}>
              <Text>{unityData.tablePrice}</Text>
            </View>
            <Text style={styles.unityName}>{"FORMAS DE PAGAMENTO"}</Text>
            <View style={styles.viewSubdata}>
              <PaymentMethods data={unityData.paymentForms} />
            </View>

            <Text style={styles.unityName}>{"DESCRIÇÃO"}</Text>
            <View style={styles.viewSubdata}>
              <Text>{unityData.description}</Text>
            </View>

            <Text style={styles.unityName}>
              {"INFORMAÇÕES DO ESTACIONAMENTO"}
            </Text>
            <View style={styles.viewSubdata}>
              {unityData.unityInfo ? (
                <Info data={unityData.unityInfo} />
              ) : (
                <Text>{"Sem informações"}</Text>
              )}
            </View>
            <Text style={styles.unityName}>{"SERVIÇOS DISPONÍVEIS"}</Text>
            <View style={styles.viewSubdata}>
              {unityData.services ? (
                <Services data={unityData.services} />
              ) : null}
            </View>
            {/* <View style={{ marginVertical: 8 }}>
                        <Botao
                            textoBotao={"VOLTAR"}
                            estilo={{ backgroundColor: Colors.SECONDARY }}
                            onPress={() => navigation.goBack()}
                        />
                    </View> */}
            {/* </View> */}
            <UnityModalPopUp
              setStatePopUp={setStatePopUp}
              isPopUpVisible={isPopUpVisible}
              showModal={{
                name: unityData.name,
                address: unityData.address,
                latitude: unityData.latitude,
                longitude: unityData.longitude,
              }}
            />
          </>
        ) : null}
      </ScrollView>
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  viewSubdata: {
    padding: 4,
    backgroundColor: Colors.SNOW,
    borderColor: Colors.SECONDARY,
    borderLeftWidth: 2,
    shadowColor: Colors.GRAY_DARK,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    borderRadius: 8,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  unityName: {
    color: Colors.SECONDARY,
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "bold",
    marginVertical: 8,
  },
});
